import RxFooter from "./RxFooter";

export default RxFooter;
